import { useState } from 'react'
import { authApi } from '@/api/auth'
import { getApiErrorMessage } from '@/api/client'
import { notify } from '@/lib/toast'

export const HANDOFF_PATH = '/auth/handoff'

export function buildHandoffUrl(websiteUrl: string, token: string): string {
  const base = String(websiteUrl || '').replace(/\/+$/, '')
  return `${base}${HANDOFF_PATH}?token=${encodeURIComponent(token)}`
}

/** Asks the API for a single-use hand-off token and sends the browser to the other website. */
export function useWebsiteSwitch() {
  const [switching, setSwitching] = useState(false)

  async function switchTo(websiteId: number) {
    setSwitching(true)
    try {
      const data = await authApi.switchWebsite(websiteId)
      window.location.assign(buildHandoffUrl(data.url, data.handoff_token))
    } catch (error) {
      notify.error(getApiErrorMessage(error, 'Could not switch website'))
      setSwitching(false)
    }
  }

  return { switchTo, switching }
}
